import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/action-bars.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ActionBarsService } from '../../services';

@Injectable()
export class ActionBarsEffects {
  private actions$ = inject(Actions);
  private service = inject(ActionBarsService);

  LoadBars$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadActionBars),
      switchMap(() =>
        this.service.getActionBars().pipe(
          map(bars => contentblockActions.LoadActionBarsSuccess({ bars })),
          catchError(error => of(contentblockActions.LoadActionBarsFail({ error })))
        )
      )
    );
  });
}
